module.exports = __webpack_public_path__ + "7af20f3d9791391d264780f34357bafe.svg";